
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SplashPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/language');
    }, 2500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-pink-600 flex flex-col items-center justify-center px-6">
      {/* Logo and App Name */}
      <div className="text-center mb-8">
        <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mb-6 mx-auto shadow-lg">
          <i className="ri-car-line text-4xl text-purple-600 w-12 h-12 flex items-center justify-center"></i>
        </div>
        <h1 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: '"Pacifico", serif' }}>
          سامي عبدالسلام
        </h1>
        <p className="text-purple-100 text-lg">
          تطبيق البحث عن أصحاب السيارات
        </p>
      </div>

      {/* Background Illustration */}
      <div className="absolute bottom-0 left-0 right-0 h-64 opacity-20">
        <img 
          src="https://public.readdy.ai/ai/img_res/209bc555cf30fb1db816acc41c8fc762.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Loading Indicator */}
      <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2">
        <div className="flex space-x-2">
          <div className="w-3 h-3 bg-white rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>
    </div>
  );
}
